import React, { useState } from 'react'
import { Form, Input, Button, Card } from 'antd'
import { LockOutlined, CheckCircleFilled, ExclamationCircleFilled } from '@ant-design/icons'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import logo from '@/assests/Shakthi Power outline logo.png'
import { api, ApiError } from '@/services/api'
import './LoginPage.css'

const ResetPasswordPage: React.FC = () => {
  const [form] = Form.useForm()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const token = searchParams.get('token') || ''
  const [loading, setLoading] = useState(false)
  const [done, setDone] = useState(false)
  const [error, setError] = useState('')

  const onFinish = async (values: { newPassword: string; confirmPassword: string }) => {
    setError('')
    if (values.newPassword !== values.confirmPassword) {
      setError('Passwords do not match.')
      return
    }
    setLoading(true)
    try {
      await api.resetPassword(token, values.newPassword)
      setDone(true)
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Cannot reach the server. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="lp-root-centered">
      <div className="lp-bg-glow glow-1" />
      <div className="lp-bg-glow glow-2" />
      <div className="lp-bg-glow glow-3" />

      <div className="lp-card-container">
        <div className="lp-logo-header">
          <img src={logo} alt="Shakthi Power Logo" className="lp-logo-main" />
        </div>

        <Card className="lp-glass-card">
          <div className="lp-card-header">
            <h2>Reset Password</h2>
            <p>Choose a new password for your account</p>
          </div>

          {error && (
            <div className="lp-error-alert">
              <ExclamationCircleFilled style={{ fontSize: 16 }} />
              <span>{error}</span>
            </div>
          )}

          {!token ? (
            <div style={{ textAlign: 'center', color: 'rgba(255,255,255,0.75)', padding: '12px 0' }}>
              <p>This reset link is missing its token. Please use the link from your email, or request a new one.</p>
              <Link to="/forgot-password" className="lp-forgot-link">Request a new link</Link>
            </div>
          ) : done ? (
            <div style={{ textAlign: 'center', color: 'rgba(255,255,255,0.75)', padding: '12px 0' }}>
              <CheckCircleFilled style={{ fontSize: 32, color: '#059669', marginBottom: 12 }} />
              <p>Your password has been reset.</p>
              <Button type="primary" size="large" block className="lp-btn-submit" onClick={() => navigate('/login')}>
                Go to Login
              </Button>
            </div>
          ) : (
            <Form form={form} layout="vertical" onFinish={onFinish} autoComplete="off" requiredMark={false} className="lp-form-dark">
              <Form.Item
                name="newPassword"
                label="New Password"
                rules={[
                  { required: true, message: 'Please enter a new password' },
                  { min: 6, message: 'Minimum 6 characters' },
                ]}
              >
                <Input.Password prefix={<LockOutlined className="input-icon" />} placeholder="Enter new password" size="large" />
              </Form.Item>

              <Form.Item
                name="confirmPassword"
                label="Confirm Password"
                rules={[{ required: true, message: 'Please confirm your new password' }]}
              >
                <Input.Password prefix={<LockOutlined className="input-icon" />} placeholder="Re-enter new password" size="large" />
              </Form.Item>

              <Form.Item style={{ marginBottom: 16 }}>
                <Button type="primary" htmlType="submit" size="large" block loading={loading} className="lp-btn-submit">
                  {loading ? 'Resetting...' : 'Reset Password'}
                </Button>
              </Form.Item>

              <div style={{ textAlign: 'center' }}>
                <Link to="/login" className="lp-forgot-link">Back to login</Link>
              </div>
            </Form>
          )}
        </Card>

        <div className="lp-footer-text">
          © {new Date().getFullYear()} Shakthi Power ERP. All rights reserved.
        </div>
      </div>
    </div>
  )
}

export default ResetPasswordPage
